import { ShopOrdersSearchRequest } from "../types/shopOrderSearchRequest";

const shopOrderKeys = {
  base: ["shopOrder"] as const,
  lists: () => [...shopOrderKeys.base, "list"] as const,
  list: (params: ShopOrdersSearchRequest) =>
    [...shopOrderKeys.lists(), params] as const,
  details: () => [...shopOrderKeys.base, "detail"] as const,
  detail: (id?: string) => [...shopOrderKeys.details(), id] as const,
};

const shopDataQueryKey = ["shopData"];

const productAdminKeys = {
  base: ["product-admin"] as const,
  details: () => [...productAdminKeys.base, "detail"] as const,
  detail: (id?: string | null) => [...productAdminKeys.details(), id] as const,
};

export { shopOrderKeys, shopDataQueryKey, productAdminKeys };
